export function addQueryObjectToUrl(urlObject, queryParams) {
    Object.keys(queryParams).forEach(key => {
        urlObject.searchParams.append(key, queryParams[key]);
    });
}
